import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { OpenQuestion } from "anketa-core/open_question";
import { OptionsQuestion } from "anketa-core/options_question";
import { TextValidator } from "anketa-core/validation";
import { getTranslation } from "../../../../";

export const getOidcSection = (defaultValues: boolean): Section => {
  const oidcSection: Section = new Section("oidc", [
    new Translation("en", "OIDC"),
    new Translation("de", "OIDC"),
  ]);
  const useAutonubilLogin = new OptionsQuestion(
    "use_autonubil_oidc",
    [
      new Translation(
        "en",
        "Would you like to log in with the same user as for the other autonubil services?",
      ),
      new Translation(
        "de",
        "Möchten Sie sich mit demselben Benutzer wie für die anderen autonubil-Dienste anmelden?",
      ),
    ],
    "default.options.yes_no",
  );
  oidcSection.addChild(useAutonubilLogin);

  let useOidc = new OptionsQuestion(
    "use_oidc",
    [
      new Translation(
        "en",
        getTranslation("en", "anketa.opsanio.customer.dashboard.oidc"),
      ),
      new Translation(
        "de",
        getTranslation("de", "anketa.opsanio.customer.dashboard.oidc"),
      ),
    ],
    "default.options.yes_no",
  );
  oidcSection.addChild(useOidc);

  let oidcRedirectUrl = new OpenQuestion("oidc_redirect", [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.oidc.redirect"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.oidc.redirect"),
    ),
  ]);
  oidcRedirectUrl.validator = new TextValidator();

  let oidcClientId = new OpenQuestion("oidc_client_id", [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.oidc.client.id"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.oidc.client.id"),
    ),
  ]);
  oidcClientId.validator = new TextValidator();

  let oidcClientSecret = new OpenQuestion("oidc_client_secret", [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.opsanio.customer.dashboard.oidc.client.secret",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.opsanio.customer.dashboard.oidc.client.secret",
      ),
    ),
  ]);
  oidcClientSecret.validator = new TextValidator();

  let oidcConnectUrl = new OpenQuestion("oidc_client_connect", [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.oidc.connect"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.oidc.connect"),
    ),
  ]);
  oidcConnectUrl.validator = new TextValidator();

  let oidcScope = new OpenQuestion("oidc_client_scope", [
    new Translation(
      "en",
      getTranslation("en", "anketa.opsanio.customer.dashboard.oidc.scope"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.opsanio.customer.dashboard.oidc.scope"),
    ),
  ]);
  oidcScope.validator = new TextValidator();

  useAutonubilLogin.addChangeListener(() => {
    const enableUseAutonubilLogin = useAutonubilLogin.fact.raw === "1";
    const enableOidcAuth = useOidc.fact.raw === "0";
    const parent = useOidc;

    const children = [
      oidcRedirectUrl,
      oidcClientId,
      oidcClientSecret,
      oidcConnectUrl,
      oidcScope,
    ];

    if (enableUseAutonubilLogin) {
      if (!oidcSection.containsChild(parent)) {
        oidcSection.addChild(parent);
      }
      if (enableOidcAuth) {
        children.forEach((child) => {
          if (!oidcSection.containsChild(child)) {
            oidcSection.addChild(child);
          }
        });
      }
    } else {
      if (oidcSection.containsChild(parent)) {
        oidcSection.removeChild(parent);
      }
      if (enableOidcAuth) {
        children.forEach((child) => {
          if (oidcSection.containsChild(child)) {
            oidcSection.removeChild(child);
          }
        });
      }
    }
  });

  useOidc.addChangeListener(() => {
    const enableOidcAuth = useOidc.fact.raw === "0";

    const children = [
      oidcRedirectUrl,
      oidcClientId,
      oidcClientSecret,
      oidcConnectUrl,
      oidcScope,
    ];

    if (enableOidcAuth) {
      children.forEach((child) => {
        if (!oidcSection.containsChild(child)) {
          oidcSection.addChild(child);
        }
      });
    } else {
      children.forEach((child) => {
        if (oidcSection.containsChild(child)) {
          oidcSection.removeChild(child);
        }
      });
    }
  });

  if (defaultValues) {
    useAutonubilLogin.setFactValue("0");
    useOidc.setFactValue(1);
  }
  return oidcSection;
};
